import { Component, ViewChild, OnInit, Input } from "@angular/core";
import { CommandsService } from "../services/commands.service";
import { LanguageService } from "../services/language.service";
import { TurtleService } from "../services/turtle.service";
import { CanvasService } from "../services/canvas.service";
import { ExamService } from "../services/exam.service";
import { LoginService } from "../services/login.service";
import { EditorContentService } from "../services/editorcontent.service";
import { DebuggerService } from "../services/debugger.service";

import { AppComponent } from "./app.component";
import { HistoryComponent } from "./history.component";
import { CanvasComponent } from "./canvas.component";
import { HeaderComponent } from "./header.component";
import { SessionStorageService } from "../services/sessionstorage.service";
import { BlocksComponent } from "./blocks.component";
import { BlocksService } from "../services/blocks.service";
import { BluetoothService } from "../services/bluetooth.service";

import { RestoreCanvasEvent } from "app/lib/Task";

import { damlev_distance } from "levenshtein-damerau";

import { ANTLRInputStream, CommonTokenStream } from "antlr4ts";
import { XLogoLexer, XLogoParser } from "app/xlogo-parser/parser";
import {
  AstTranslatorVisitor,
  XLogoInterpreter,
  SemanticVerifier,
  SemanticErrorCause,
  ANTLRSyntaxErrorListener,
  SyntaxErrorCause,
  RuntimeError
} from "app/xlogo-parser";
import {
  ProgDecl,
  BuiltInCommand,
  SpecialBuiltInCommand,
  MakeStmt,
  PrintStmt
} from "app/xlogo-parser/ir/ast";
import { CanvasActionSet } from "app/actionSets/canvasActionSet";

@Component({
  selector: "app-input",
  templateUrl: "./input.component.html",
  providers: []
})
export class InputComponent implements OnInit {
  @ViewChild("canvasID") canvasComponent: CanvasComponent;

  /** The maximum amount of time in milliseconds that the interpreter is allowed to execute at full speed.
   * The screen gets updated when this limit exceeds.
   */
  private MAX_MS_TIME_EXECUTE: number = 10;

  // execution speed, integer in range 0..10
  private speedFromChild: number;

  // variables related to Editor
  private errorIndizes = [];
  static updateTurtleSpeed = function(speed: number) {};
  //private variables = new Array();

  // The newest visitor that is currently running (or has been running)
  private currentInterpreter: XLogoInterpreter;
  private definedVariables: Map<string, any>;

  static stopVisitor = function() {};

  // Used for debug mode
  static stepForward = function() {};
  static stepBackward = function() {};
  // TODO: the whole thing with the highlighting is not solved very elegantly

  //highlighting errors in Editor
  private tok;
  static markers = [];

  //static object
  static inputComponent;

  constructor(
    private et: EditorContentService,
    private debuggerService: DebuggerService,
    private lang: LanguageService,
    private commandsService: CommandsService,
    private sessionstorage: SessionStorageService,
    private blocks: BlocksService,
    private examService: ExamService,
    private login: LoginService
  ) {
    InputComponent.inputComponent = this;

    this.examService.reExecutionNeededEmitter.subscribe(event =>
      this.reStoreCanvas(event)
    );

    InputComponent.stopVisitor = function() {
      if (this.currentInterpreter.isRunning()) this.stopVisitor();
    }.bind(this);

    InputComponent.stepForward = function() {
      console.log("\n[INPT] Next button has been clicked.");
      this.debuggerService.stepForward(
        this.runInterpreter.bind(this),
        this.currentInterpreter
      );
    }.bind(this);

    InputComponent.stepBackward = function() {
      console.log("\n[INPT] Prev button has been clicked.");
      this.debuggerService.stepBackward(
        this.runInterpreter.bind(this),
        this.currentInterpreter
      );
    }.bind(this);
  }

  reStoreCanvas(event: RestoreCanvasEvent) {
    if (event != null) {
      var editorContent = event.editorContent;
      var commands = event.commands;
      for (var i = 0; i < commands.length; i++) {
        if (commands[i] != null) {
          //this.executeCommand(commands[i], this.et.ParsedPrograms, false);
        }
      }
    }
  }

  ngOnInit() {
    // Set up input line as one-line ace editor
    this.commandsService.setLangService(this.lang);
    this.commandsService.initInputLine(this.addElem.bind(this));

    //reference to current this object, because we lose in callback we lose the this and all of its variables
    var cur = this;

    //disable editor
    this.et.editorEnabler.emit(false);

    //set headline text to "initialize"
    this.lang.setHeadLineTextTo(
      this.lang.translateKey("init"),
      "headerText_init"
    );

    //register eventlistener for editor change
    this.et.textInDisplayHasChangedEmitter.subscribe(() =>
      this.onEditorChanged()
    );

    //ugly hack for first syntax check, which takes much longer: start on startup...
    setTimeout(
      function() {
        CanvasComponent.canvasComponent.load();
        this.initializeParser();
      }.bind(this),
      350
    );
  }

  onEditorChanged() {
    //read in content of editor
    var cur = this;
    var text = this.et.getCurrentEditorText().toLowerCase();
    clearTimeout(cur.speedFromChild);
  }

  initializeParser() {
    //load speedRange and editorContent from last session from localstorage, TODO: retrieve text for multiple tabs
    this.sessionstorage.retrieveSpeed();
    this.sessionstorage.retrieveEditorContent();

    //this.executeCommand("pu fd 0 pd cs", this.et.ParsedPrograms, false);
    this.commandsService.inputLine.setReadOnly(false);
    (<HTMLButtonElement>document.getElementById("stopExec")).disabled = true;
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleButton()
    );
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleSwitch()
    );
    this.lang.setHeadLineTextTo(
      this.login.headLineTextUserOrXLogoOnline(),
      "headerText_XLogoOnline"
    );
    this.et.enableEditor();
  }

  //adds the errors from "errorsToAdd" to errorindizes (t: current method text, off: method offset)
  addErrorsToErrorIndizes(c, errorsToAdd, t, off) {
    for (let error of errorsToAdd) {
      c.handleError(error, t);
      c.errorIndizes.push({
        row: off + error.line,
        col: 0,
        start: 0,
        stop: 100,
        text: error.msg,
        type: "error"
      });
    }
  }

  //returns "errors" array from LogoEditorVisitor
  getErrorArray(ourEditor): Array<Object> {
    var returnArray = ourEditor.errors;
    return returnArray;
  }

  //returns all the text that's in the context, in order to be able to display later what the user wrote too much
  getTooMuch(ctx): String {
    //get children text
    var text = ctx.constructor.toString().substr(9, 8);
    if (text !== "Terminal") {
      var temp = "";
      for (var i = 0; i < ctx.children.length; i++) {
        temp = temp + this.getTooMuch(ctx.children[i]);
      }
      return temp;
    } else {
      return ctx.getText() + " ";
    }
  }

  // the the current text element to the CommandService, which is bound to the HistoryComponent and will thus annotate the command there
  // if there is no error in the command itself
  addElem(newElem: string) {
    if (newElem) {
      this.executeCommand(newElem.toLowerCase(), this.et.ParsedPrograms, true);
    }
  }

  private leaveDebugMode() {
    this.debuggerService.endSession();
    this.debuggerService.hideDebugElements();
  }

  private debugCallback(visitorState) {
    let continueExecution = this.debuggerService.callback(visitorState);
    console.log("[INPT] Waiting for user input.");
    return continueExecution;
  }

  //set Editor Content to text programmatically, used to create testcases and solutions for Klett
  setEditorText(text) {
    this.et.setTextOfCurrentEditorProgrammatically(text);
  }

  // execute the text in content (used to execute code originating from input field)
  // set editorContentGiven to true if you don't want it to check the editor (while testing exercises from our course book)
  executeCommand(
    content: string,
    editorContent: Map<string, ProgDecl>,
    addToHistory: boolean
  ): any {
    if (this.currentInterpreter && this.currentInterpreter.isRunning()) {
      this.stopVisitor();
    }

    CanvasComponent.stop = false;
    this.commandsService.addCommand(content);

    const inputStream = new ANTLRInputStream(content.toLowerCase());
    const inputLexer = new XLogoLexer(inputStream);
    inputLexer.removeErrorListeners();
    const inputTokenStream = new CommonTokenStream(inputLexer);
    const inputParser = new XLogoParser(inputTokenStream);
    inputParser.removeErrorListeners();
    const syntaxErrorListener = new ANTLRSyntaxErrorListener();
    inputParser.addErrorListener(syntaxErrorListener);

    const inputContext = inputParser.inputLines();

    if (inputParser.numberOfSyntaxErrors !== 0) {
      const errMsgs: string[] = [];

      for (const err of syntaxErrorListener.errorList) {
        errMsgs.push(
          this.lang.translateKey(
            SyntaxErrorCause[err.cause],
            err.translationParameters
          )
        );
      }

      this.commandsService.addErrorMessage(errMsgs, content);
      return;
    }
    const visitor = new AstTranslatorVisitor([]);
    const inputResult = visitor.visit(inputContext);
    const semanticVerifier = new SemanticVerifier();

    const verifyResult = semanticVerifier.check(inputResult, editorContent);

    if (verifyResult.errors.length !== 0) {
      const errMsgs: string[] = [];

      for (const err of verifyResult.errors) {
        errMsgs.push(
          this.lang.translateKey(
            SemanticErrorCause[err.cause],
            err.translationParameters
          )
        );
      }

      this.commandsService.addErrorMessage(errMsgs, content);
      return;
    }
    const interpreter = new XLogoInterpreter(
      inputResult,
      new CanvasActionSet(this.canvasComponent),
      editorContent,
      this.definedVariables
    );

    this.currentInterpreter = interpreter;

    // Initialize the first block. This is hacky
    this.currentInterpreter.continueExecution();

    if (
      this.debuggerService.getDebugMode() &&
      (inputResult.rwChildren.length > 1 ||
        (inputResult.rwChildren.length === 1 &&
          !(inputResult.getChildren()[0] instanceof BuiltInCommand) &&
          !(inputResult.getChildren()[0] instanceof SpecialBuiltInCommand) &&
          !(inputResult.getChildren()[0] instanceof MakeStmt) &&
          !(inputResult.getChildren()[0] instanceof PrintStmt)))
    ) {
      this.debuggerService.showDebugElements();
      this.debuggerService.callback(this.currentInterpreter);
    } else {
      setTimeout(this.runInterpreter.bind(this), 1);
    }

    this.lang.setHeadLineTextTo(
      this.lang.translateKey("executingVisitor"),
      "headerText_XLogoOnline"
    );
    this.disableUI();
  }

  async runInterpreter() {
    if (!this.currentInterpreter.isRunning()) {
      this.stopVisitor();
      return;
    }

    let delay_ms: number = -1;
    const start_time = Date.now();
    let suspendExecution = false;

    // Execute for MAX_MS_TIME_EXECUTE miliseconds since setTimeout requires a lot of time that slows the interpreter down.
    while (
      delay_ms <= 0.1 &&
      this.currentInterpreter.isRunning() &&
      Date.now() < start_time + this.MAX_MS_TIME_EXECUTE &&
      !suspendExecution
    ) {
      delay_ms = HeaderComponent.headerComponent.calculateCurrentspeed();

      try {
        this.currentInterpreter.continueExecution();
      } catch (err) {
        if (!(err instanceof Error)) {
          console.error("Error is not an Error");
          console.error(err);
          this.commandsService.addErrorMessage(
            [
              this.lang.translateKey("runtime_error_generic", {
                msg: err.message
              })
            ],
            // TODO: Give useful information where it happened
            ""
          );
        } else if (!(err instanceof RuntimeError)) {
          console.error("Error is not of type RuntimeError");
          console.error(err);
          this.commandsService.addErrorMessage(
            [
              this.lang.translateKey("runtime_error_generic", {
                msg: err.message
              })
            ],
            // TODO: Give useful information where it happened
            ""
          );
        } else {
          let errMsg: string = err.message;
          if (err.translationKey) {
            errMsg = this.lang.translateKey(
              err.translationKey,
              err.translationParameters
            );
          }
          this.commandsService.addErrorMessage(
            [errMsg],
            // TODO: Give useful information where it happened
            ""
          );
        }
        this.canvasComponent.flush();
        this.stopVisitor();
        return;
      }

      if (this.debuggerService.getDebugMode()) {
        suspendExecution = this.debuggerService.callback(
          this.currentInterpreter
        );
      }
    }

    if (this.currentInterpreter.isPaused())
      delay_ms = Math.max(
        this.currentInterpreter.getPausedMilliseconds(),
        delay_ms
      );

    if (delay_ms > 0 || suspendExecution) this.canvasComponent.flush();
    if (!suspendExecution) setTimeout(this.runInterpreter.bind(this), delay_ms);
  }

  private stopVisitor() {
    if (this.debuggerService.getDebugMode()) {
      this.debuggerService.endSession();
      this.debuggerService.hideDebugElements();
    }

    this.currentInterpreter.stopExecution();
    this.canvasComponent.flush();
    this.definedVariables = this.currentInterpreter.State.getAllVariables();
    this.lang.setHeadLineTextTo(
      this.login.headLineTextUserOrXLogoOnline(),
      "headerText_XLogoOnline"
    );
    this.commandsService.setCommandLineText("");
    this.enableUI();
  }

  disableUI() {
    this.commandsService.inputLine.setReadOnly(true);
    (<HTMLButtonElement>document.getElementById("stopExec")).disabled = false;
    if (!this.debuggerService.getDebugMode()) {
      this.debuggerService.disableButton(
        this.debuggerService.getDebugToggleButton()
      );
      this.debuggerService.disableButton(
        this.debuggerService.getDebugToggleSwitch()
      );
    }
    this.et.disableEditor();
  }

  enableUI() {
    // Enable UI elements again
    this.commandsService.inputLine.setReadOnly(false);
    (<HTMLButtonElement>document.getElementById("stopExec")).disabled = true;
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleButton()
    );
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleSwitch()
    );
    this.et.enableEditor();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/input.component.ts